module.exports = __webpack_public_path__ + "img/FGr_Räumen_A_Radlader.d5d6efc1.svg";